module.exports = __webpack_public_path__ + "59b5ad184965e7276b5d8605cbcca9f2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-28.png
// module id = 3136
// module chunks = 0